import { render, staticRenderFns } from "./coupon-button.vue?vue&type=template&id=043838f0&scoped=true&"
import script from "./coupon-button.vue?vue&type=script&lang=ts&"
export * from "./coupon-button.vue?vue&type=script&lang=ts&"
import style0 from "./coupon-button.vue?vue&type=style&index=0&id=043838f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043838f0",
  null
  
)

export default component.exports